import { useSnapshot } from "valtio";
import { state } from "../store";
import "./PresetsPanel.css";

export default function PresetsPanel() {
  const snap = useSnapshot(state);

  const isOpen = snap.openedPanel === "presets";

  const handleClose = () => {
    state.openedPanel = null;
  };

  // Define predefined color presets - harmonized combinations
  const colorPresets = [
    {
      name: "Classic White & Blue",
      colors: {
        hull: "#f8fafc", // Pearl White
        seats: "#b9d2fc", // Light Blue
        accent: "#0d7c9f", // Ocean Blue
        deck: "#c9a96e", // Teak Wood
        glass: "#e3edfd", // Sky Blue
      },
    },
    {
      name: "Black & Orange",
      colors: {
        hull: "#1f2937", // Midnight Black
        seats: "#1f2937", // Midnight Black
        accent: "#ba3009", // Sunset Orange
        deck: "#8b4513", // Dark Cherry
        glass: "#9ca3af", // Light Gray
      },
    },
    {
      name: "Electric Blue",
      colors: {
        hull: "#1e47e7", // Electric Blue
        seats: "#b9d2fc", // Light Blue
        accent: "#f8fafc", // Pearl White
        deck: "#c9a96e", // Teak Wood
        glass: "#e3edfd", // Sky Blue
      },
    },
    {
      name: "Deep Blue Classic",
      colors: {
        hull: "#9eadc8", // Deep Blue
        seats: "#f8fafc", // Pearl White
        accent: "#0d7c9f", // Ocean Blue
        deck: "#8b4513", // Mahogany
        glass: "#b9d2fc", // Light Blue
      },
    },
    {
      name: "Midnight Luxury",
      colors: {
        hull: "#1f2937", // Midnight Black
        seats: "#4b5563", // Dark Gray
        accent: "#882f54", // Deep Purple
        deck: "#251a0d", // Dark Cherry
        glass: "#9ca3af", // Light Gray
      },
    },
    {
      name: "Coral Sunset",
      colors: {
        hull: "#882f54", // Coral Pink
        seats: "#ba3009", // Sunset Orange
        accent: "#f8fafc", // Pearl White
        deck: "#a0522d", // Cherry Wood
        glass: "#fda4af", // Light Pink
      },
    },
    {
      name: "Royal Purple",
      colors: {
        hull: "#802305", // Royal Purple
        seats: "#882f54", // Deep Purple
        accent: "#f8fafc", // Pearl White
        deck: "#45331a", // Dark Cherry
        glass: "#e9d5ff", // Light Purple
      },
    },
    {
      name: "Sky Blue Classic",
      colors: {
        hull: "#d4c9a4", // Sky Blue
        seats: "#e3edfd", // Sky Blue
        accent: "#1e47e7", // Electric Blue
        deck: "#c9a96e", // Teak Wood
        glass: "#f8fafc", // Pearl White
      },
    },
    {
      name: "Ocean White",
      colors: {
        hull: "#3167a0", // Ocean Blue
        seats: "#f8fafc", // Pearl White
        accent: "#b9d2fc", // Light Blue
        deck: "#daa520", // Oak Wood
        glass: "#e3edfd", // Sky Blue
      },
    },
  ];

  const applyPreset = (preset) => {
    // Apply preset colors to specific elements
    state.hullColor = preset.colors.hull;
    state.accentColor = preset.colors.accent;
    state.deckColor = preset.colors.deck;
    state.seatsColor = preset.colors.seats;

    // Do NOT close panel automatically - let user close manually
  };

  // Helper function to convert hex to HSL
  const hexToHsl = (hex) => {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: Math.round(h * 360),
      s: Math.round(s * 100),
      l: Math.round(l * 100),
    };
  };

  return (
    <>
      {isOpen && (
        <>
          <h2 className="panel-title panel-title-presets">PRESET COLORS</h2>
          <div className="presets-wrapper">
            <div className="presets-panel">
              <div className="presets-grid">
                {colorPresets.map((preset, index) => (
                  <div
                    key={index}
                    className="preset-item"
                    onClick={() => applyPreset(preset)}
                  >
                    <div
                      className="preset-gradient-ball"
                      style={{
                        "--color1": preset.colors.hull,
                        "--color2": preset.colors.seats,
                        "--color3": preset.colors.accent,
                        "--color4": preset.colors.deck,
                        "--color5": preset.colors.glass,
                      }}
                    ></div>
                  </div>
                ))}
              </div>
              <button className="close-button-presets" onClick={handleClose}>
                <svg viewBox="0 0 24 24">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}
